export enum LabelType {
  STARS = 'stars',
  LOCK = 'lock',
  PRO_ACTIVITY = 'pro-activity',
  PREMIUM_ACTIVITY = 'premium-activity',
  GIFT_ACTIVITY = 'gift-activity',
  DONE_ACTIVITY = 'done-activity',
  FREE_TIER = 'free-tier',
  PREMIUM_TIER = 'premium-tier',
  PRO_TIER = 'pro-tier'
}

export type LabelConfig = {
  title?: string
  textColor?: string
  backgroundColor: string
  renderIcon?: (large?: boolean) => JSX.Element
}

export type LabelProps = {
  type: LabelType
  title?: string
  withoutText?: boolean
  large?: boolean
}
